import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

const axiosConfig = {
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
};

const handleAxiosError = (err, rejectWithValue) => {
    if (err.message === "Network Error") {
        return rejectWithValue({ message: "Network Error" });
    }
    return rejectWithValue(
        err.response?.data || { message: "Something went wrong" }
    );
};

export const contactUsSubmit = createAsyncThunk(
    'contactUs/contactUsSubmit',
    async (contactUsData, { rejectWithValue }) => {
        try {

            const response = await axios.post(`${PUBLIC_BASE_URL}/contact-us-forms/create-contact-us-form`, contactUsData, axiosConfig);
            return response.data;
        } catch (err) {
           return handleAxiosError(err, rejectWithValue);
        }
    }
);
